import { AxiosUtil } from '../utils/axios-util'
import { errorResponseNotification } from './notification-service'

export const getReleases = () =>
  AxiosUtil.get('/external/v1/releases').catch(err => {
    errorResponseNotification(err)
    throw err
  })
